import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { DEFAULT_SEARCH_DISTANCE, IAddress, ILatLon, MAPBOX_TOKEN } from '@curbnturf/entities';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocationFacade } from './+state/location.facade';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  loaded = false;

  constructor(
    private http: HttpClient,
    private locationFacade: LocationFacade,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {}

  getCurrentLocation(): Observable<ILatLon> {
    return from(
      new Promise<ILatLon>((resolve, reject) => {
        if (isPlatformBrowser(this.platformId) && window && window.navigator && window.navigator.geolocation) {
          return window.navigator.geolocation.getCurrentPosition(
            (position) => {
              const center = {
                lat: position.coords.latitude,
                lon: position.coords.longitude,
              };

              if (!this.loaded) {
                this.loaded = true;
                this.locationFacade.select({ center, distance: DEFAULT_SEARCH_DISTANCE });
              }

              return resolve(center);
            },
            (error) => {
              switch (error.code) {
                case 1:
                  // console.log('Permission Denied');
                  break;
                case 2:
                  // console.log('Position Unavailable');
                  break;
                case 3:
                  // console.log('Timeout');
                  break;
                default:
                // console.log('Error getting location');
              }

              return reject(error);
            },
          );
        }

        return reject('This requires a browser');
      }),
    );
  }

  addressGeocode(address: IAddress): Observable<ILatLon> {
    const searchText = encodeURIComponent(
      address.address + ', ' + address.city + ', ' + address.state + ' ' + address.zipcode,
    );

    return this.http
      .get<ILatLon>(`https://api.mapbox.com/search/geocode/v6/forward?q=${searchText}&access_token=${MAPBOX_TOKEN}`)
      .pipe(
        map((response: any) => {
          if (response?.features?.length > 0) {
            const feature = response.features[0];
            return { lat: feature?.geometry?.coordinates[1], lon: feature?.geometry?.coordinates[0] };
          } else {
            throw new Error('No results found');
          }
        }),
      );
  }
}
